<template>
  <div role="main" class="category-page">
    <div v-if="$apollo.loading && !categories" class="h-screen p-5">
      <Spinner />
    </div>
    <div v-if="categories" class="all-categories">
      <div
        :class="`category-${$route.params.category}`"
        class="all-categories__heading"
        style="color: var(--category-color)"
      >
        {{ $t('seo.title.all') }}
      </div>
      <ul>
        <li v-for="category in categories.nodes" :key="category.slug">
          <nuxt-link :to="`/ressort/${category.slug}`">
            {{ category.name }}
          </nuxt-link>
          <div v-if="category.description">
            {{ category.description }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  apollo: {
    categories: {
      query: require('~base/graphql/queries/FetchAllCategories.gql'),
      prefetch: true,
    },
  },
}
</script>

<style>
@import '~pages/ressort/all.css';
</style>
